import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SectionContainer = styled.section`
  width: 100%;
`;

export const MainViewContainer = styled.section`
  width: 100%;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  margin-top: 30px;
  margin-left: 0px;
`;

export const OuterSection = styled.section`
  width: 95%;
  border-radius: 5px;
  overflow: visible;
  opacity: ${(props) => (props.$isLoading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$isLoading ? "none" : "auto")};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  background: ${(props) => props.background ?? "#fff"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  padding: ${(props) => props.padding ?? "12px 16px"};
  box-shadow: ${(props) => props.boxShadow ?? "0 0px 0 0 #e5e5e5"};
  border-radius: ${(props) => props.borderRadius ?? "0px 0 0 0px"};
  margin: ${(props) => props.margin ?? "0px"};
  border: ${(props) => props.border ?? "none"};
  border-bottom: ${(props) => props.borderBottom ?? "none"};
  border-left: ${(props) => props.borderLeft ?? "none"};
  border-right: ${(props) => props.borderRight ?? "none"};
  border-top: ${(props) => props.borderTop ?? "none"};
  overflow: ${(props) => props.overflow ?? "visible"};
  align-items: ${(props) => props.alignItems ?? "initial"};
`;

export const GridCellOld = styled.div`
  font-family: Lato;
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  color: #fff;
`;

export const GridCell = styled.div`
  font-family: Lato;
  font-size: ${(props) => props.fontSize ?? "14px"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  color: ${(props) => props.color ?? "#fff"};
  display: ${(props) => props.display ?? "block"};
  align-items: ${(props) => props.alignItems ?? "initial"};
  text-align: ${(props) => props.textAlign ?? "initial"};
  justify-content: ${(props) => props.justifyContent ?? "initial"};
  border-left: ${(props) => props.borderLeft ?? "none"};
  padding: ${(props) => props.padding ?? "0"};
`;

export const ContainerLabel = styled.label`
  display: block;
  width: auto;
  font-family: Lato;
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "0.9375rem;"};
  line-height: 1;
  color: ${(props) => props.color ?? " #1bace4"};
  margin-bottom: 6px;
  cursor: ${(props) => props.cursor ?? "default"};
  text-decoration: ${(props) => props.textDecoration ?? "none"};
`;

export const Title = styled.h2`
  width: 100%;
  text-align: left;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
  align-content: center;
`;

export const SpanButton = styled.span`
  font-weight: normal;
  line-height: normal;
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-left: ${(props) => props.marginLeft ?? "0"};
`;

export const InvoiceButton = styled(BaseButton)`
  border: 1px solid ${(props) => props.background};
  background: ${(props) => props.border};
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: auto;
  margin: 1rem 0 0 0;
  min-width: 220px;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const QuantityLineOuter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 153px;
`;

export const FlexRowItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorMessagePara = styled.p`
  font-size: 1rem;
  font-family: Lato;
  line-height: 1;
  text-transform: initial;
  font-weight: bold;
  color: red;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
`;
